import React, { useState } from 'react';

import { Button } from '@iq/react-components';
import { useDispatch } from 'react-redux';
import { notifyPageChanges } from '../../bundles/layouts';

const Delete = ({ title = 'Delete', onDelete }) => {
  const [needsConfirmation, setNeedsConfirmation] = useState(false);
  const dispatch = useDispatch();
  // eslint-disable-next-line no-shadow
  const handleDelete = () => {
    setNeedsConfirmation(false);
    onDelete();
    dispatch(notifyPageChanges('deletePage'));
  };

  return (
    <div className="delete-component">
      {needsConfirmation ? (
        <>
          <div className="confirmation">Are you sure?</div>
          <div className="buttons">
            <Button
              activity="secondary"
              onClick={() => setNeedsConfirmation(false)}
            >
              Cancel
            </Button>
            <Button
              onClick={handleDelete}
              activity="danger"
            >
              Yes, delete
            </Button>
          </div>
        </>
      ) : (
        <div className="buttons">
          <Button
            activity="secondary"
            onClick={() => setNeedsConfirmation(true)}
          >
            {title}
          </Button>
        </div>
      )}
    </div>
  );
};

export default Delete;
